import React, { useState, useEffect } from "react";
import { Button, Table } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../config";
import LoadingSpinner from "../../components/LoadingSpinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

const EmployeeSalaryView = () => {
  const token = localStorage.getItem("authToken");
  const { id } = useParams();
  const navigate = useNavigate();
  const [employee, setEmployee] = useState(null);
  const [salaryDetails, setSalaryDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchEmployeeSalary = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_URL}payroll/employee/view-salary/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setEmployee(response.data.data.employee || null);
      setSalaryDetails(response.data.data.res || []);
      setLoading(false);
    } catch (error) {
      setError("Error fetching data");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchEmployeeSalary();
    }
  }, [id]);

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      {loading && <LoadingSpinner />}
      <div id="content" className="">
        <div className="row pb-2">
          <div className="col-md-6">
            <h4 className="panel-title">
              Employee Salary :: {employee?.user_user_fullname || "Loading..."}
            </h4>
          </div>
          <div className="col-md-6" style={{ textAlign: "right" }}>
            <Button
              variant="default"
              size="sm"
              onClick={() => navigate("/Payroll/Employee/index/")}
              className="btn-default"
            >
              <b>
                <FontAwesomeIcon icon={faChevronLeft} />
              </b>{" "}
              Return to Employee
            </Button>
          </div>
        </div>

        <div className="panel panel-default with-rounded-corner with-shadow">
          {salaryDetails.length > 0 ? (
            <Table className="table">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Title</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                {salaryDetails.map((salary, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{salary.title}</td>
                    <td>{moneyFormatIndia(salary.formula_value)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div className="panel-body">
              {error ? error : "No salary details found"}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const moneyFormatIndia = (value) => {
  if (isNaN(value)) return "₹0";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
  }).format(Number(value));
};

export default EmployeeSalaryView;
